// extracted by mini-css-extract-plugin
export default {"container":"NVModal_container__NpcKJ","content":"NVModal_content__jegWa"};